import i18n from "@/plugins/i18n";
import moment from 'moment'

export default {
  browse: {
    table: {
      headers: [
        {
          text: i18n.t("model.prop.no"),
          value: "index",
          sortable: false,
        },
        {
          text: i18n.t("model.prop.created"),
          value: "timestampCreated",
          filterable: false,
        },
        {
          text: "Mobile",
          value: "accountMobile",
        },
        {
          text: "Status",
          value: "upgradeRequestStatus",
        },
      ],
    },
  },
  read: {
    tabs: [
      {
        key: "Info",
        label: i18n.t("string.info"),
      },
    ],
    table: {
      headers: [
        {
          text: "Mobile",
          value: "accountMobile",
        },
        {
          text: "Status",
          value: "upgradeRequestStatus",
        },
         {
          text: "Plan",
          value: "Plan",
        },
         {
          text: "Amount",
          value: "amount",
        },
         {
          text: "Coupon Key",
          value: "couponKey",
        },
         {
          text: "Receipt Image",
          value: "receiptImageUrl",
        },
        {
          text: "Applied At",
          value: "timestampCreated",
          filterable: false,
        },
        {
          text: i18n.t("model.prop.lastUpdated"),
          value: "timestampUpdated",
          filterable: false,
        },
      ],
    },
  },
  add: true,
  verify: {
     fields: [
      {
        type: "date",
        key: "dateStart",
        name: "Date Start",
        min: moment().format("YYYY-MM-DD"),
        defaultValue: moment().format("YYYY-MM-DD"),
      },
      {
        type: "date",
        key: "dateEnd",
        name: "Date End",
        min: moment().format("YYYY-MM-DD"),
        defaultValue: moment().add(1, "years").format("YYYY-MM-DD"),
      },
    ],
    rules: {
      sponsorshipPackageKey: [(v) => !!v || 'Sponsorship Package Key required'],
    },
  },
  reject: true,
  edit: false,
  delete: true,
};
